import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M3.628 2.265A1.942 1.942 0 0 1 5.444 1c.83 0 1.535.524 1.815 1.265h7.064c.37 0 .677.307.677.677 0 .37-.307.677-.677.677H7.259a1.941 1.941 0 0 1-1.815 1.265 1.941 1.941 0 0 1-1.816-1.265h-1.95A.682.682 0 0 1 1 2.942c0-.37.307-.677.677-.677h1.951Zm1.816 1.264a.586.586 0 1 0 0-1.174.586.586 0 1 0 0 1.174Zm5.69 2.529c-.83 0-1.535.524-1.815 1.265H1.677A.682.682 0 0 0 1 8c0 .37.307.677.677.677H9.32c.28.741.984 1.265 1.815 1.265s1.536-.524 1.816-1.265h1.373c.37 0 .677-.307.677-.677a.682.682 0 0 0-.677-.677H12.95a1.941 1.941 0 0 0-1.816-1.265ZM11.721 8a.586.586 0 1 1-1.174 0 .586.586 0 1 1 1.174 0Zm-3.974 3.116c-.83 0-1.535.524-1.815 1.265H1.677a.682.682 0 0 0-.677.677c0 .37.307.678.677.678h4.255c.28.74.984 1.264 1.815 1.264s1.536-.524 1.816-1.264h4.76c.37 0 .677-.308.677-.678a.682.682 0 0 0-.677-.677h-4.76a1.941 1.941 0 0 0-1.816-1.265Zm.587 1.942a.586.586 0 1 1-1.174 0 .586.586 0 1 1 1.174 0Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n
];
function r(h, l) {
  return e(), c("svg", o, [...a]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
